/* eslint-disable no-console */

// AWS Cognito for authenticating user https://github.com/aws/amazon-cognito-identity-js

import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

// import AWS from 'aws-sdk';
// SHARED

export function configureCognito(): void {
  Amplify.configure({
    Auth: {
      userPoolId: COGNITO_USER_POOL_ID,
      userPoolWebClientId: COGNITO_CLIENT_ID,
      region: COGNITO_REGION,
    },
  });
}

// function getUserPool() {
//   const userData = {
//     UserPoolId: COGNITO_USER_POOL_ID,
//     ClientId: COGNITO_CLIENT_ID,
//   };

//   const userPool = new CognitoUserPool(userData);

//   return userPool;
// }

// REFRESH EXISTING User
export async function GetCurrentCognitoUser(): Promise<any> {
  const user = await Auth.currentAuthenticatedUser();
  return user;
}

// REFRESH EXISTING User
export async function GetCurrentCognitoSession(): Promise<any> {
  const session = await Auth.currentSession();
  return session;
}

export async function CognitoRefresh(): Promise<any> {
  const session = await Auth.currentSession();
  return session;
  // if (session === undefined) {
  //   return false;
  // }
  // const refreshToken = session.getRefreshToken();
  // if (AWS.config.credentials.needsRefresh()) {
  //   cognitoUser.refreshSession(refreshToken, (err, session) => {
  //     if (err) {
  //       console.log(err);
  //     } else {
  //       AWS.config.credentials.params.Logins[
  //         `cognito-idp.${COGNITO_REGION}.amazonaws.com/${COGNITO_USER_POOL_ID}`
  //       ] = session.getIdToken().getJwtToken();
  //       AWS.config.credentials.refresh((err) => {
  //         if (err) {
  //           console.log(err);
  //         } else {
  //           console.log('TOKEN SUCCESSFULLY UPDATED');
  //         }
  //       });
  //     }
  //   });
  // }
}

// LOGOUT
export async function CognitoLogout(): Promise<any> {
  // const userPool = getUserPool();

  // const cognitoUser = userPool.getCurrentUser();
  // if (cognitoUser != null) {
  //   cognitoUser.signOut();
  // }
  await Auth.signOut();
}

// LOGIN
export async function CognitoLogin({ email, password }): Promise<any> {
  const user = await Auth.signIn(email, password);
  return user;
  // const userPool = getUserPool();

  // const authenticationData = {
  //   Username: email,
  //   Password: password,
  // };
  // const authenticationDetails = new AuthenticationDetails(authenticationData);

  // const p = new Promise((res, rej) => {
  //   const userData = {
  //     Username: email,
  //     Pool: userPool,
  //   };
  //   const cognitoUser = new CognitoUser(userData);
  //   cognitoUser.authenticateUser(authenticationDetails, {
  //     onSuccess(result) {
  //       res(result);
  //     },

  //     onFailure(error) {
  //       // console.log(error);
  //       rej(error);
  //     },
  //   });
  // });
  // return p;
}

// FORGOTTEN PASSWORD
export async function CognitoForgotPassword({ email }): Promise<any> {
  // const userPool = getUserPool();

  // const p = new Promise((res, rej) => {
  //   const userData = {
  //     Username: email,
  //     Pool: userPool,
  //   };
  //   const cognitoUser = new CognitoUser(userData);
  //   cognitoUser.forgotPassword({
  //     onSuccess(result) {
  //       res(result);
  //     },
  //     onFailure(error) {
  //       rej(error);
  //     },
  //   });
  // });
  // return p;
  await Auth.forgotPassword(email);
}

// CHANGE PASSWORD
export async function CognitoChangePassword({
  email,
  password,
  verificationCode,
}): Promise<any> {
  // const userPool = getUserPool();
  // const p = new Promise((res, rej) => {
  //   const userData = {
  //     Username: email,
  //     Pool: userPool,
  //   };
  //   const cognitoUser = new CognitoUser(userData);
  //   // console.log(verificationCode, password);
  //   cognitoUser.confirmPassword(verificationCode, password, {
  //     onSuccess(result) {
  //       // console.log(result);
  //       res(result);
  //     },
  //     onFailure(error) {
  //       // console.log(error);
  //       rej(error);
  //     },
  //   });
  // });
  // return p;
  await Auth.forgotPasswordSubmit(email, verificationCode, password);
}

// SIGNUP
export async function CognitoSignUp(
  {
    email, mobile, password, firstName, lastName,
  },
  clientMetadata,
): Promise<any> {
  // const userPool = getUserPool();
  // instantiate a promise so we can work with this async easily
  // try {
  const { user } = await Auth.signUp({
    username: email.toLowerCase(),
    password,
    attributes: {
      email: email.toLowerCase(),
      phone_number: mobile,
      'custom:firstName': firstName,
      'custom:lastName': lastName,
    },
    clientMetadata,
  });
  return { result: user };
  // }
  // catch (error) {
  //   throw error;
  // }
}

export async function CognitoConfirmEmail(
  username,
  verificationCode,
  clientMetadata,
): Promise<any> {
  // const p = new Promise((res, rej) => {
  //   try {
  //     const userPool = getUserPool();
  //     const userData = {
  //       Username: username.toLowerCase(),
  //       Pool: userPool,
  //     };

  //     const cognitoUser = new CognitoUser(userData);
  //     cognitoUser.confirmRegistration(
  //       verificationCode,
  //       true,
  //       (error, result) => {
  //         if (error) {
  //           rej(error);
  //           return;
  //         }
  //         res({ result });
  //       },
  //       clientMetadata,
  //     );
  //   } catch (e) {
  //     rej(e);
  //   }
  // });
  // return p;
  await Auth.confirmSignUp(username, verificationCode, {
    clientMetadata,
  });
}

export async function CognitoResendVerificationCode(username): Promise<any> {
  // const p = new Promise((res, rej) => {
  //   try {
  //     const userPool = getUserPool();
  //     const userData = {
  //       Username: username.toLowerCase(),
  //       Pool: userPool,
  //     };

  //     const cognitoUser = new CognitoUser(userData);
  //     cognitoUser.resendConfirmationCode((error, result) => {
  //       if (error) {
  //         rej(error);
  //         return;
  //       }
  //       res({ result });
  //     });
  //   } catch (e) {
  //     rej(e);
  //   }
  // });
  // return p;

  await Auth.resendSignUp(username);
}
